/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_shorts_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grab the cover image of any YouTube Short. Paste a Shorts link (youtube.com/shorts/…) and download the thumbnail in every available size.`)
};

const es_yt_shorts_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtén la imagen de portada de cualquier YouTube Short. Pega un enlace de Shorts (youtube.com/shorts/…) y descarga la miniatura en todos los tamaños disponibles.`)
};

const de_yt_shorts_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hol dir das Titelbild jedes YouTube Shorts. Füge einen Shorts-Link ein (youtube.com/shorts/…) und lade das Thumbnail in jeder verfügbaren Größe herunter.`)
};

const nl_yt_shorts_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download de cover-afbeelding van elke YouTube Short. Plak een Shorts-link (youtube.com/shorts/…) en download de thumbnail in elk beschikbaar formaat.`)
};

const fr_yt_shorts_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupérez l’image de couverture de n’importe quel YouTube Short. Collez un lien Shorts (youtube.com/shorts/…) et téléchargez la miniature dans toutes les tailles disponibles.`)
};

const it_yt_shorts_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottieni l'immagine di copertina di qualsiasi YouTube Short. Incolla un link Shorts (youtube.com/shorts/…) e scarica la miniatura in ogni dimensione disponibile.`)
};

const pt_br2_yt_shorts_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegue a imagem de capa de qualquer YouTube Short. Cole um link de Shorts (youtube.com/shorts/…) e baixe a thumbnail em todos os tamanhos disponíveis.`)
};

const pt_yt_shorts_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenha a imagem de capa de qualquer YouTube Short. Cole um link de Shorts (youtube.com/shorts/…) e descarregue a miniatura em todos os tamanhos disponíveis.`)
};

const ja_yt_shorts_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意のYouTube Shortsのカバー画像を取得しましょう。Shortsのリンク（youtube.com/shorts/…）を貼り付けて、利用可能なすべてのサイズでサムネイルをダウンロードできます。`)
};

const zh_yt_shorts_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取任意 YouTube Short 的封面图片。粘贴 Shorts 链接（youtube.com/shorts/…），下载所有可用尺寸的缩略图。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_shorts_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_shorts_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_shorts_intro", locale)
	if (locale === "en") return en_yt_shorts_intro(inputs)
	if (locale === "es") return es_yt_shorts_intro(inputs)
	if (locale === "de") return de_yt_shorts_intro(inputs)
	if (locale === "nl") return nl_yt_shorts_intro(inputs)
	if (locale === "fr") return fr_yt_shorts_intro(inputs)
	if (locale === "it") return it_yt_shorts_intro(inputs)
	if (locale === "pt-BR") return pt_br2_yt_shorts_intro(inputs)
	if (locale === "pt") return pt_yt_shorts_intro(inputs)
	if (locale === "ja") return ja_yt_shorts_intro(inputs)
	return zh_yt_shorts_intro(inputs)
};